import { useCallback, useEffect, useMemo, useState } from 'react';
import { TagService } from '../services/tag.service';
import { TagResponse } from '../services/responses/tag.response';

/// Catálogo de tags para marcar e filtrar leads, carregado uma vez por tela.
export const useTags = () => {
    const [tags, setTags] = useState<TagResponse[]>([]);
    const service = useMemo(() => new TagService(), []);

    const fetchAll = useCallback(async () => {
        try {
            const res = await service.getList();

            setTags(res.data.data ?? []);
        } catch (e) {
            console.error(e);
        }
    }, [service]);

    useEffect(() => {
        fetchAll();
    }, [fetchAll]);

    return { tags, refetch: fetchAll };
};
